import Head from "../Components/Header/header";
import Login from "../Components/Login/login";
import Login2 from "../Components/Login/login2";

function Loginpage() {
  return (
    <>
      {/* <Head /> */}
      {/* <Login /> */}
      <Login2 />
    </>
  );
}
export default Loginpage;
